/*
 * @Author: your name
 * @Date: 2020-05-22 11:21:09
 * @LastEditTime: 2020-07-09 14:59:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \h5_active_warehouse\audioGuide\audioGuide\src\api\request.js
 */
import axios from 'axios'
// import { merchantId, uid, token } from '@/api/api'
import { merchantId, uid,AudioId,token,openid,imgHost } from '@/api/api'
import md5 from 'js-md5'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_API, // api 的 base_url
  baseURL: `https://www.xiaoniren.cn/saasapi`,
  timeout: 50000 // request timeout
})
export const searchCityWeather = axios.create({
  // baseURL: process.env.BASE_API, // api 的 base_url
  baseURL: `/dev`,
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['data'] = `{"merchant_id":${merchantId || 0} , "uid":${JSON.parse(sessionStorage.getItem('openIdData') || '{}').id||0}} `
    config.headers['ak'] = '999'
    config.headers['token'] = decodeURIComponent( JSON.parse(sessionStorage.getItem('openIdData') || '{}').token);
    // config.headers['token'] = token
    config.headers['time'] = new Date()
      .getTime()
      .toString()
      .substr(0, 10)
    const temp =
        '999' +
        '9ad96eb8f271a358' +
        `merchant_id${merchantId}uid${JSON.parse(sessionStorage.getItem('openIdData') || '{}').id}` +
        new Date()
          .getTime()
          .toString()
          .substr(0, 10)

    config.headers['sign'] = md5(temp)
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // response.headers['Content-Type'] = 'multipart/form-data'
    // console.log(response.data)
    return response
  },
  error => {
    console.log('err' + error) // for debug
    // MessageBox({
    //   message: error.message
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js